<template>
  <div class="absolute md:rounded pin-t pin-l h-1 w-screen bg-bar-grey md:relative custom-width">
    <div
      :style="{
        width: `${intRatio}%`,
      }"
      class="h-full bg-orange mb-1 md:rounded"
    />
    <div
      class="flex items-center justify-evenly w-full"
    >
      <div
        v-for="index in numberOfDots"
        :key="index"
        :class="{'bg-orange': (index / (numberOfDots + 1) <= ratio)}"
        class="rounded-full bg-bar-grey h-1 w-1"
      />
    </div>
  </div>
</template>

<script>
export default {

  name: 'TheTopProgressBar',
  props: {
    ratio: {
      type: Number,
      default: 0,
    },
    numberOfDots: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    intRatio() {
      return parseInt(this.ratio * 100, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .custom-width {
    width: 420px;
  }
}
</style>
